{
  "version": 1,
  "asset_id": "74aa2f34-935a-4469-b50e-c82f8608ed48",
  "project_id": "1e4fe108-4756-4697-836a-97816893411c",
  "url": "/__l5e/assets-v1/74aa2f34-935a-4469-b50e-c82f8608ed48/tf-logo-96.png",
  "r2_key": "a/v1/1e4fe108-4756-4697-836a-97816893411c/74aa2f34-935a-4469-b50e-c82f8608ed48/tf-logo-96.png",
  "original_filename": "tf-logo-96.png",
  "size": 2765,
  "content_type": "image/png",
  "created_at": "2026-08-27T07:22:43Z"
}
